// @flow

//
// FP
//
import S, { F } from '../../../../lib/trix-fp-fantasy';

//
// Trix Middleware
//
import {
    get as httpGet,
} from '../../../../lib/trix-web-middleware-commons';


// readEmptyRetailSale :: () -> Future Error RetailSale
const readEmptyRetailSale = (container: any) => (sale: any) => {
    return new F.Future((reject, resolve) => {
        const url = container._links.searchRetailSaleById.href.replace('{id}', '');
        httpGet(
            // url
            url,

            // options
            null,

            // reject callback
            reject,

            // resolve callback
            (data) => resolve(data.body)
        )

        // TODO: fix after migration to Axious. Check how to add AbortController 
        // to axious call
        return () => null;
    });
};

// buildNewSale :: Action -> Future Error Data
const buildNewSale = (env: any): any => (data: any, container: any, meta?: any): any => (cfg: any): any => (action: any) => {
    return S.pipe([
        // Sale -> Future () Sale
        F.resolve,

        // Future () SaleSaleItemResult -> Future Error SaleSaleItemResult
        // S.chain (readEmptyRetailSale(container)),

        // Future Error Sale -> Future Error Sale
        S.map((sale: any) => {
            const actions: Array<any> = [];

            env.relativeNavigateTo('');

            // PATCH: cleanup sale for better visual experience.
            // NOTE: this should be part of halui
            // const setSaleActionId = 'trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer';
            // // PATCH:
            // // actions.push(
            // //     env.ducks.actions[setSaleActionId].data.setData(sale)
            // // );
            // actions.push(
            //     env.ducks.actions[setSaleActionId].data.setData({
            //         id: '',
            //         documentDate: '',
            //         documentNo: '',
            //         customer: {},
            //         warehouse: {},
            //         paymentDue: {},
            //         saleInvoiceState: '',
            //         shippingNetAmount: {},
            //         shippingTaxAmount: {},
            //         shippingTotalAmount: {},
            //         stockNetAmount: {},
            //         stockTaxAmount: {},
            //         stockTaxPercent: {},
            //         stockTotalAmount: {},
            //         auditMetaData: {},
            //         _links: sale._links
            //     })
            // );
            
            // PATCH: cleanup sale lines for better visual experience.
            // NOTE: this should be part of halui
            const setSaleLineActionId = 'trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.currentRetailSaleLinesTable';
            actions.push(
                env.ducks.actions[setSaleLineActionId].data.setData({
                    items: [],
                    page: { size: 100, totalElements: 0, totalPages: 1, number: 0 }
                })
            );

            // complete execution with success
            actions.push(cfg.actions.operationExecuted_Success({}));

            return(actions);
        })

    ]) (data);
}

export default buildNewSale;